/**
 * @param {Date} anchorDate
 * @param {Date} [fromDate]
 */
export const getNextMonthlyPeriodEnd = (anchorDate, fromDate = new Date()) => {
  const safeAnchor = anchorDate instanceof Date && Number.isFinite(anchorDate.getTime())
    ? anchorDate
    : fromDate;
  const anchorDay = safeAnchor.getDate();

  const candidateForMonth = (year, month) => {
    const lastDay = new Date(year, month + 1, 0).getDate();
    return new Date(year, month, Math.min(anchorDay, lastDay), 23, 59, 59, 999);
  };

  let candidate = candidateForMonth(fromDate.getFullYear(), fromDate.getMonth());
  if (candidate.getTime() <= fromDate.getTime()) {
    candidate = candidateForMonth(fromDate.getFullYear(), fromDate.getMonth() + 1);
  }

  return candidate.getTime();
};

/**
 * @param {{ messagesCount?: unknown, periodEnd?: unknown, createdAt: Date, now?: number }} usage
 */
export const normalizeUsageCycle = ({ messagesCount, periodEnd, createdAt, now = Date.now() }) => {
  const normalizedCount = typeof messagesCount === 'number' && Number.isFinite(messagesCount)
    ? Math.max(0, messagesCount)
    : 0;
  const normalizedPeriodEnd = typeof periodEnd === 'number' && Number.isFinite(periodEnd)
    ? periodEnd
    : 0;

  if (normalizedPeriodEnd > now) {
    return { messagesCount: normalizedCount, periodEnd: normalizedPeriodEnd };
  }

  return {
    messagesCount: 0,
    periodEnd: getNextMonthlyPeriodEnd(createdAt, new Date(now))
  };
};
